import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import fire_img from '../../../Assets/Images/Training/Training Program/fire_program.jpg'

const Fire_Risk_and_Vulnerabilities_Informal_Settlements = () => {
    return (
        <div className="mt-5">
            <h4>3 - Days Professional Development Program on ‘ Fire Risk and Vulnerabilities in Informal Settlements: Complexities, Modelling, and Strategies for Risk Mitigation’</h4>

            <div className="card mt-5">
                <img
                    src={fire_img}
                    className="card-img-top"
                    alt="Poster"
                />
            </div>
            <Link to="https://www.linkedin.com/pulse/fire-rips-through-pietermaritzburgs-jika-joe-informal-raath-brownie" target='_blank'>
                <p className='text-primary text-end'>Image Credit Goes To</p>
            </Link>

            <div className="mt-5">
                <p>This course provides an in-depth exploration of the existing multiple complexities and unique fire vulnerabilities in informal settlements, focusing on the socio-economic, environmental, behavioral,  physical , and infrastructural factors that contribute to the heightened risk of fire hazards. Participants will examine the complex challenges of fire safety in informal settlements, where building density, limited access to resources, and inadequate infrastructure exacerbate the potential for devastating fires. The participants will also examine the possible fire safety approaches and role of technological advancements, contributing in fire risk management and fire risk reduction.</p>
            </div>

            <div>

                <p><strong>Beneficiaries:</strong> Urban managers from ULBs, Urban Development Authorities, State/PSU project units, contractors, Urban planners, Architect, policymakers, Disaster Management Professional and Researchers, Professionals in Civil Engineering, Fire safety Engineers  (FSE), Fire safety Officers (FSO), Fire safety professionals and Researchers,  and related disciplines.</p>
                <p><strong>Aim:</strong> To equip professionals with the skills to assess and mitigate the complex fire risks in informal settlements by integrating fire dynamics and fire risk modeling, policy, and community-based strategies, corroborating fire risk management and fire risk reduction.</p>

                <p><strong>Objectives:</strong></p>
                <ul>
                    <li>Sensitizing the professionals with the gravity of issues of fire risk and hazards in informal settlements </li>
                    <li>Understand the unique fire hazards and vulnerabilities present in informal settlements.</li>
                    <li>Explore methodologies for fire risk assessment and computational modelling in these contexts.</li>
                    <li>Evaluate and propose effective strategies for fire risk mitigation and community resilience.</li>
                    <li>Gain insight into the socio-economic factors influencing fire vulnerability.</li>
                </ul>

                <p className='mt-4'><strong>Timeline & Duration:</strong> 3 days - 24 Hours (2-4 Credits)</p>
                <p className='mt-4'><strong>Mode:</strong> Non-Hybrid and Non-blended (Offline)</p>

            </div>

        </div>
    );
};

export default Fire_Risk_and_Vulnerabilities_Informal_Settlements;